import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { FieldElement } from "@/react/types/Element";

export const elementToBlock = (
  element: FieldElement,
  fieldIndex: number,
): BaseBlock => ({
  id: element.id.toString(),
  type: "FormShortAnswerBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: element.attributes.label,
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: element.attributes.placeholder || "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: element.attributes.required,
    },
    hidden: {
      prop: "other",
      type: "boolean",
      value: element.attributes.hidden,
    },
  },
  meta: {
    elementType: "field",
    fieldType: "short_answer",
    elementId: element.id,
    elementableId: element.elementable_id,
    position: element.position,
    parentElementId: element.parent_element_id,
    fieldIndex,
    profileFieldId: element.attributes.profile_field_id,
  },
});
